/**
 * assets/chakraw-pricing.js  v2.1
 * ChakRaw – Árkalkulátor + Élő Előnézet
 * JAVÍTÁSOK v2.0 → v2.1:
 *   - Dupla betöltés ellen: window.CkrPricingInitialized guard
 *   - CkrCtx timing fix: doInit() retry amíg window.CkrCtx nem töltődik be
 *   - fmt(zone.base) → fmt(prices.base) javítva az ár-sor megjelenítésnél
 */

if (window.CkrPricingInitialized) {
  // Script már fut – ne inicializálj újra
} else {
window.CkrPricingInitialized = true;

(function () {
  'use strict';

  // ── INIT GUARD ────────────────────────────────────────────────
  var wrap = document.getElementById('ckrpWrap');
  if (!wrap) return;

  // C-t az init tölti fel, amint CkrCtx elérhető
  var C = {};

  // ── CSAT SZÍN PALETTA ─────────────────────────────────────────
  var BUCKLE_PALETTE = {
    hajnal:             '#e8a9a0',
    tuzvarazs:          '#802e0dff',
    napsugar:           '#e8c34a',
    lombzold:           '#6ec483ff',
    egkek:              '#5fa8d3',
    'kozmikus-kek':     '#2b3a8f',
    ejszaka:            '#16161f',
    levendula:          '#b497d6'
  };

  // ── ZÓNÁK (árak nélkül – a Shopify variánsokból olvassuk) ─────
  var ZONES = [
    { min:20, max:31, name:'XS–S',
      label: (C.locale && C.locale.zoneLabels && C.locale.zoneLabels['XS-S'] && C.locale.zoneLabels['XS-S'].label) || 'Kis és közepes kutyák',
      desc:  (C.locale && C.locale.zoneLabels && C.locale.zoneLabels['XS-S'] && C.locale.zoneLabels['XS-S'].desc)  || 'Pl. chihuahua',
      color:'#7aabf0', border:'#1e3a70', bg:'rgba(14,26,48,.5)', emoji:'🐾' },
    { min:32, max:37, name:'M',
      label: (C.locale && C.locale.zoneLabels && C.locale.zoneLabels['M'] && C.locale.zoneLabels['M'].label) || 'Közepes kutyák',
      desc:  (C.locale && C.locale.zoneLabels && C.locale.zoneLabels['M'] && C.locale.zoneLabels['M'].desc)  || 'Pl. beagle',
      color:'#6ab87a', border:'#1e5c24', bg:'rgba(14,32,16,.5)', emoji:'🐕' },
    { min:38, max:43, name:'L',
      label: (C.locale && C.locale.zoneLabels && C.locale.zoneLabels['L'] && C.locale.zoneLabels['L'].label) || 'Nagy kutyák',
      desc:  (C.locale && C.locale.zoneLabels && C.locale.zoneLabels['L'] && C.locale.zoneLabels['L'].desc)  || 'Pl. labrador',
      color:'#f0886a', border:'#5c1e1e', bg:'rgba(42,14,14,.5)', emoji:'🦮' },
    { min:44, max:49, name:'XL',
      label: (C.locale && C.locale.zoneLabels && C.locale.zoneLabels['XL'] && C.locale.zoneLabels['XL'].label) || 'Nagy és nagytestű kutyák',
      desc:  (C.locale && C.locale.zoneLabels && C.locale.zoneLabels['XL'] && C.locale.zoneLabels['XL'].desc)  || 'Pl. golden retriever',
      color:'#c9a84c', border:'#4a3a10', bg:'rgba(30,20,8,.5)', emoji:'🐕‍🦺' },
    { min:50, max:55, name:'XXL',
      label: (C.locale && C.locale.zoneLabels && C.locale.zoneLabels['XXL'] && C.locale.zoneLabels['XXL'].label) || 'Nagytestű kutyák',
      desc:  (C.locale && C.locale.zoneLabels && C.locale.zoneLabels['XXL'] && C.locale.zoneLabels['XXL'].desc)  || 'Pl. rottweiler',
      color:'#a855f7', border:'#4c1d95', bg:'rgba(30,10,60,.5)', emoji:'🦴' },
    { min:56, max:62, name:'XXXL',
      label: (C.locale && C.locale.zoneLabels && C.locale.zoneLabels['XXXL'] && C.locale.zoneLabels['XXXL'].label) || 'Óriás termetű kutyák',
      desc:  (C.locale && C.locale.zoneLabels && C.locale.zoneLabels['XXXL'] && C.locale.zoneLabels['XXXL'].desc)  || 'Pl. újfoundlandi',
      color:'#60c0e0', border:'#0e3a5c', bg:'rgba(7,24,40,.5)', emoji:'🐻' }
  ];

  // ── ÁLLAPOT ───────────────────────────────────────────────────
  var S = {
    cm:         26,
    arch:       'both',
    buckleExtra: 0,
    buckleLabel: 'Bújtatós',
    buckleIcon:  '🔘',
    buckleType:  'bujtatos',
    gem:         false,
    stop:        false
  };

  // ── SEGÉDEK ───────────────────────────────────────────────────
  function getZone(cm) {
    return ZONES.find(function (z) { return cm >= z.min && cm <= z.max; }) || ZONES[0];
  }

  function fmt(n) {
    if (!n && n !== 0) return '–';

    var shopify = window.Shopify || {};
    var activeCurr = (shopify.currency && shopify.currency.active)
      ? shopify.currency.active
      : (C.cartCurrency || C.shopCurrency || 'HUF');

    // Ne szorozzuk be duplán árfolyammal, mert a Shopify a variáns árat már az aktuális pénznemben adja át!
    var converted = n;

    // Ha euró van, alkalmazzuk a Shopify Markets stílusú .95-ös kerekítést
    if (activeCurr === 'EUR') {
      // Vesszük az egész eurót lefelé kerekítve, és levonunk belőle 0.05-öt (így lesz pl. 23.00-ból 22.95)
      // Vagy ha a matematika úgy hozza, a Math.floor(converted) - 0.05 adja ki a .95-ös véget.
      var baseEuro = Math.floor(converted);
      converted = baseEuro - 0.05; 
    }

    var zeroDecimal = ['HUF','JPY','KRW','VND','ISK','CLP'].indexOf(activeCurr) !== -1;

    try {
      return new Intl.NumberFormat(
        document.documentElement.lang || 'hu',
        {
          style: 'currency',
          currency: activeCurr,
          minimumFractionDigits: zeroDecimal ? 0 : 2,
          maximumFractionDigits: zeroDecimal ? 0 : 2
        }
      ).format(converted);
    } catch (e) {
      return zeroDecimal
        ? Math.round(converted).toLocaleString('hu') + '\u00a0' + activeCurr
        : converted.toFixed(2) + '\u00a0' + activeCurr;
    }
  }
  // Shopify variáns ár lekérése a zóna neve alapján
  function getVariantPrices(zoneName) {

    var variants = C.variants || [];

    var match = variants.find(function(v) {

      return v.option1 && v.option1.trim() === zoneName.trim()

        && v.option2 && v.option2.trim() === buckleOpt.trim()

        && v.option3 && v.option3.trim() === extrasOpt.trim();

    });

    if (!match) return { base: 0, list: 0, available: true };

    var divisor = 100; // HUF: 1 Ft = 1 minor unit (Shopify 100-as osztót használ)

    return {

      base:      Math.round(match.price / divisor),

      list:      match.compare_at_price ? Math.round(match.compare_at_price / divisor) : 0,

      available: match.available

    };

  }

  function clamp(v, a, b) { return Math.max(a, Math.min(b, parseInt(v) || a)); }
  function el(id)          { return document.getElementById(id); }
  function setVisible(id, show) {
    var e = el(id);
    if (e) e.style.display = show ? 'flex' : 'none';
  }

  // ── ELEM REFERENCIÁK ─────────────────────────────────────────
  var collarImg     = el('ckrpCollarImg');
  var overlayKapocs = el('ckrpOverlayKapocs');
  var overlayMedal  = el('ckrpOverlayMedal');
  var buckleImg     = el('ckrpBuckleImg');
  var buckleSvg     = el('ckrpBuckleSvg');
  var buckleSvgLbl  = el('ckrpBSvgLabel');

  // ── SLIDER TICK-EK ────────────────────────────────────────────
  var ticksContainer = el('ckrpSliderTicks');
  if (ticksContainer) {
    ZONES.forEach(function (z, i) {
      var show = [z.min];
      if (i === ZONES.length - 1) show.push(z.max);
      show.forEach(function (v) {
        var pct = (v - 20) / (62 - 20) * 100;
        var t   = document.createElement('div');
        t.className  = 'ckrp-tick';
        t.dataset.v  = v;
        t.style.left = pct + '%';
        t.style.transform = 'translateX(-50%)';
        t.innerHTML  = '<div class="ckrp-tick-line"></div>'
          + '<div class="ckrp-tick-lbl">' + v + '</div>';
        t.addEventListener('click', function () { setCm(parseInt(t.dataset.v)); });
        ticksContainer.appendChild(t);
      });
    });
  }

  function highlightTicks(zone) {
    document.querySelectorAll('.ckrp-tick').forEach(function (t) {
      var v      = parseInt(t.dataset.v);
      var active = v >= zone.min && v <= zone.max;
      var ln  = t.querySelector('.ckrp-tick-line');
      var lbl = t.querySelector('.ckrp-tick-lbl');
      if (ln)  ln.style.background  = active ? zone.color : '#2a2f55';
      if (lbl) lbl.style.color      = active ? zone.color : '#4a5070';
      if (lbl) lbl.style.fontWeight = active ? '600' : '400';
    });
  }

  function updateSliderTrack(cm) {
    var slider = el('ckrpSizeSlider');
    if (!slider) return;
    slider.style.setProperty('--pct', (cm - 20) / (62 - 20) * 100 + '%');
  }

  // ── PREVIEW FRISSÍTŐ ─────────────────────────────────────────
  function updatePreview(zone) {

    // 1. COLLAR KÉP
    if (collarImg) {
      var newSrc = '';
      if (S.arch === 'both') {
        newSrc = C.imgCombined || '';
      } else if (S.arch === 'female') {
        newSrc = S.gem ? (C.imgFemale || C.imgFemaleSima || '') : (C.imgFemaleSima || C.imgFemale || '');
      } else if (S.arch === 'male') {
        newSrc = S.gem ? (C.imgMale || C.imgMaleSima || '') : (C.imgMaleSima || C.imgMale || '');
      }
      if (newSrc && collarImg.src !== newSrc) {
        collarImg.style.opacity   = '0';
        collarImg.style.transform = 'scale(.97)';
        setTimeout(function () {
          collarImg.src             = newSrc;
          collarImg.style.opacity   = '1';
          collarImg.style.transform = 'scale(1)';
        }, 220);
      }
    }

    // 2. KAPOCS OVERLAY
    var showKapocs = S.stop && !S.gem && S.arch !== 'both';
    if (overlayKapocs) {
      overlayKapocs.classList.toggle('ckrp-overlay--hidden', !showKapocs);
      if (showKapocs && C.imgKapocs) {
        var kImg = overlayKapocs.querySelector('img');
        if (kImg && kImg.src !== C.imgKapocs) kImg.src = C.imgKapocs;
      }
    }

    // 3. MEDÁL OVERLAY (a díszített fotóban már benne van, nincs réteg)
    if (overlayMedal) overlayMedal.classList.add('ckrp-overlay--hidden');

    // 4. CSAT SAROK KÉP
    var gSuffix   = S.arch === 'male' ? 'Mal' : 'Fem';
    var typeKey   = S.buckleType.charAt(0).toUpperCase() + S.buckleType.slice(1);
    var buckleSrc = C['img' + typeKey + gSuffix] || '';

    if (buckleImg && buckleSvg) {
      if (buckleSrc) {
        buckleImg.style.display = 'block';
        buckleSvg.style.display = 'none';
        if (buckleImg.src !== buckleSrc) {
          buckleImg.style.opacity = '0';
          setTimeout(function () {
            buckleImg.src           = buckleSrc;
            buckleImg.style.opacity = '1';
          }, 140);
        }
      } else {
        buckleImg.style.display = 'none';
        buckleSvg.style.display = 'block';
        if (buckleSvgLbl) buckleSvgLbl.textContent = S.buckleLabel.toUpperCase();
        var colorSlug = S.arch === 'male' ? C.maleBuckleColorSlug : C.femaleBuckleColorSlug;
        var hex       = BUCKLE_PALETTE[colorSlug] || '#c9a84c';
        document.querySelectorAll('.ckrp-buckle-tint').forEach(function (t) {
          t.setAttribute('stroke', hex);
        });
      }
    }

    // Sarok címke
    var cornerLbl  = el('ckrpBuckleCornerLabel');
    if (cornerLbl) {
      var colorName = S.arch === 'male' ? C.maleBuckleColorName : C.femaleBuckleColorName;
      cornerLbl.textContent = colorName ? (S.buckleLabel + ' · ' + colorName) : S.buckleLabel;
    }

    // 5. BADGE-EK
    var badgeGem    = el('ckrpBadgeGem');
    var badgeKapocs = el('ckrpBadgeKapocs');
    if (badgeGem)    badgeGem.style.display    = S.gem  ? 'block' : 'none';
    if (badgeKapocs) badgeKapocs.style.display = S.stop ? 'block' : 'none';
    if (S.gem) {
      var badgeGemText  = el('ckrpBadgeGemText');
      var activeGemName = S.arch === 'male' ? C.malGem : C.femGem;
      if (badgeGemText && activeGemName) badgeGemText.textContent = activeGemName;
    }


   // 6. MÉRET BADGE + CSAT SAROK – csak archetípus választás után
      var sizeBadgeWrap = el('ckrpSizeBadge');
      if (sizeBadgeWrap) sizeBadgeWrap.style.display = S.arch === 'both' ? 'none' : 'block';
      var sizeBadgeText = el('ckrpSizeBadgeText');
      if (sizeBadgeText) sizeBadgeText.textContent = zone.name + ' · ' + S.cm + ' cm';

      var buckleCorner = el('ckrpBuckleCorner');
      if (buckleCorner) buckleCorner.style.display = S.arch === 'both' ? 'none' : 'block';

    // 7. KONFIG CSÍK
    var archName  = S.arch === 'female' ? C.femaleName
      : S.arch === 'male' ? C.maleName
      : (C.femaleName || '') + ' & ' + (C.maleName || '');
    var csiArch   = el('ckrpCsiArchetype');
    var csiBuckle = el('ckrpCsiBuckle');
    var csiSize   = el('ckrpCsiSize');
    if (csiArch)   csiArch.textContent   = archName;
    if (csiBuckle) csiBuckle.textContent = S.buckleLabel;
    if (csiSize)   csiSize.textContent   = S.cm + ' cm · ' + zone.name;
  }

  // ── FŐ UI FRISSÍTŐ ────────────────────────────────────────────
  function updateUI() {
    var cm    = S.cm;
    var zone  = getZone(cm);
    var buckleOpt = S.buckleLabel === 'SafeLock' ? 'SafeLock' : 'Alap';
    var extrasOpt = S.gem ? 'Ásványmedál' : S.stop ? 'Kapocs' : 'Sima';

    var prices = (function() {
      var variants = C.variants || [];
      var match = variants.find(function(v) {
        return v.option1 === zone.name
          && v.option2 === buckleOpt
          && v.option3 === extrasOpt;
      });
      if (!match) return { base: 0, list: 0, available: true };
      return {
        base:      Math.round(match.price / 100),
        list:      match.compare_at_price
                    ? Math.round(match.compare_at_price / 100) : 0,
        available: match.available
      };
    })();

    var total = prices.base;
    var list  = prices.list;
    var disc  = (list > total && list > 0)
      ? Math.round((list - total) / list * 100) : 0;
    
    // Méret kijelző
    var sizeVal = el('ckrpSizeVal');
    if (sizeVal) sizeVal.textContent = cm + ' cm';

    // Zóna badge
    var zoneBadge = el('ckrpZoneBadge');
    if (zoneBadge) {
      zoneBadge.style.cssText = 'background:' + zone.bg + ';border:1px solid '
        + zone.border + ';color:' + zone.color
        + ';border-radius:10px;padding:9px 14px;margin-top:10px;'
        + 'display:flex;align-items:center;gap:10px;transition:all .3s';
      zoneBadge.innerHTML = '<span style="font-size:1.1rem">' + zone.emoji + '</span>'
        + '<div><strong>' + zone.name + ' méret — ' + zone.label + '</strong>'
        + '<div style="margin-top:2px;opacity:.7">' + zone.desc + '</div></div>';
    }

    // ── ÁR SOROK ──
    var rz = el('ckrpRowZone');
    var rb = el('ckrpRowBase');
    var rt = el('ckrpRowTotal');
    if (rz) rz.textContent = zone.name;
    if (rb) rb.textContent = fmt(prices.base);
    setVisible('ckrpRowBuckle', false);
    setVisible('ckrpRowGem',    false);
    setVisible('ckrpRowStop',   false);
    if (rt) rt.textContent = fmt(total);

    // Végső ár
    // 'both' esetén ár összesítő elrejtve
    var priceSummary = document.querySelector('.ckrp-price-summary');
    if (priceSummary) {
      priceSummary.style.opacity = S.arch === 'both' ? '0' : '1';
      priceSummary.style.pointerEvents = S.arch === 'both' ? 'none' : 'auto';
    }
    var orderSummary = el('ckrpOrderSummary');
    if (orderSummary) {
      orderSummary.style.opacity = S.arch === 'both' ? '0' : '1';
    }
    var pb = el('ckrpPriceBig');
    if (pb) {
      pb.style.opacity = '0';
      setTimeout(function () { 
        // Megkeressük a Shopify hivatalos kerekített árát a DOM-ból, 
        // de ha nem találja, visszatér az eredeti fmt(total)-hoz biztonsági mentésként
        var shopifyPriceEl = document.querySelector('.price-item--regular, .price__regular .price-item, .product__price .money, [data-product-price]');
        pb.textContent = shopifyPriceEl ? shopifyPriceEl.textContent.trim() : fmt(total); 
        pb.style.opacity = '1'; 
      }, 120);
    }
    var pw = el('ckrpPriceWas');  if (pw) pw.textContent = list > 0 ? fmt(list) : '';
    var ps = el('ckrpPriceSave'); if (ps) ps.textContent = disc > 0 ? ('−' + disc + '%') : '';
    var pn = el('ckrpPriceNote');
    if (pn) pn.textContent = zone.name + ' mérettartomány ('
      + zone.min + '–' + zone.max + ' cm) · ' + zone.label;

    // Variáns ID + kosár gomb
    updateVariantId(zone.name);
    // ── RENDELÉSI PROPERTY-K SZINKRONIZÁLÁSA ─────────────────
    var sizeProp = el('ckrpSizeProp');
    var zoneProp = el('ckrpZoneProp');
    if (sizeProp) sizeProp.value = S.cm + ' cm';
    if (zoneProp) zoneProp.value = zone.name + ' (' + zone.min + '–' + zone.max + ' cm)';

    // Slider
    updateSliderTrack(cm);
    highlightTicks(zone);

    // Preview
    updatePreview(zone);

    // Összefoglaló
    updateSummary(zone, prices);
  }

  // ── SHOPIFY VARIÁNS ID ────────────────────────────────────────
  function updateVariantId(zoneName) {
    var variants = C.variants || [];
    var hiddenId = el('ckrpVariantId');
    var cartBtn  = el('ckrpCartBtn');
    if (!hiddenId || !variants.length) return;

    // 'both' esetén nem lehet kosárba rakni
    var cartBtn = el('ckrpCartBtn');
    if (S.arch === 'both') {
      if (cartBtn) {
        cartBtn.disabled = true;
        cartBtn.textContent = '✦ Válassz archetípust';
      }
      return;
    }

    var buckleOpt = S.buckleLabel === 'SafeLock' ? 'SafeLock' : 'Alap';
    var extrasOpt = S.gem ? 'Ásványmedál' : S.stop ? 'Kapocs' : 'Sima';

    var match = variants.find(function(v) {
      return v.option1 === zoneName
        && v.option2 === buckleOpt
        && v.option3 === extrasOpt;
    });

    if (match) {
      hiddenId.value = match.id;
      if (cartBtn) {
        cartBtn.disabled    = !match.available;
        cartBtn.textContent = match.available ? '✦ Kosárba teszem' : '✦ Elfogyott';
      }
      var nativeSel = document.querySelector('select[name="id"]');
      if (nativeSel) nativeSel.value = match.id;
    }
  }

  // ── ÖSSZEFOGLALÓ ─────────────────────────────────────────────
  function updateSummary(zone, prices) {
    var summaryEl = el('ckrpOrderSummary');
    if (!summaryEl) return;

    var archText = S.arch === 'female' ? (C.femaleName || '')
      : S.arch === 'male' ? (C.maleName || '')
      : (C.femaleName || '') + ' & ' + (C.maleName || '');

    var gemName = S.arch === 'male' ? C.malGem : C.femGem;

    var parts = [
      '<strong>' + (C.sign || 'Csillagjegy') + ' Energia Nyakörv</strong>',
      archText,
      S.buckleLabel + ' csat'
    ];
    if (S.gem)              parts.push('Ásványmedál (' + (gemName || '') + ')');
    if (S.stop && !S.gem) parts.push('Energiakapocs');
    parts.push(zone.name + ' méret · ' + S.cm + ' cm');

    summaryEl.innerHTML =
      '<div class="ckrp-sum-header">✦ Személyre szabott választásod ✦</div>'
      + parts.join('<span class="ckrp-sum-sep"> · </span>');

    summaryEl.classList.remove('ckrp-anim-in');
    void summaryEl.offsetWidth;
    summaryEl.classList.add('ckrp-anim-in');
  }

  // ── CM SETTER ─────────────────────────────────────────────────
  function setCm(v) {
    S.cm = clamp(v, 20, 62);
    var slider  = el('ckrpSizeSlider');
    var cmInput = el('ckrpCmInput');
    if (slider)  slider.value  = S.cm;
    if (cmInput) cmInput.value = S.cm;
    updateUI();
  }

  // ── ARCHETÍPUS VÁLASZTÓ ───────────────────────────────────────
  function selectArch(arch) {
    S.arch = arch;

    ['both', 'female', 'male'].forEach(function (a) {
      var btn = el('ckrpArch' + a.charAt(0).toUpperCase() + a.slice(1));
      if (!btn) return;
      btn.classList.toggle('active', a === arch);
      btn.setAttribute('aria-pressed', a === arch ? 'true' : 'false');
    });

    var lbl = el('ckrpArchLabel');
    var vibeLbl = el('ckrpVibeText');

    if (lbl) {
      if (arch === 'female') {
        lbl.textContent = C.femaleName || '';
        if (vibeLbl) vibeLbl.textContent = C.femaleVibe || '';
      } else if (arch === 'male') {
        lbl.textContent = C.maleName || '';
        if (vibeLbl) vibeLbl.textContent = C.maleVibe || '';
      } else {
        lbl.textContent = (C.femaleName || '') + ' & ' + (C.maleName || '');
        if (vibeLbl) vibeLbl.textContent = 'Vibe check'; // <--- EZ LESZ OTT MINDKET ESETÉN
      }
    }

    var prop = el('ckrpArchProp');
    if (prop) prop.value = arch === 'female' ? (C.femaleName || '')
      : arch === 'male' ? (C.maleName || '') : 'Mindkét';

    if (arch === 'both') {
      if (S.gem)  setGemState(false);
      if (S.stop) setStopState(false, false);
    } else {
      if (!S.gem) setGemState(true);
    }

    if (S.gem) {
      var gemName = arch === 'male' ? C.malGem : C.femGem;
      var gemDesc = el('ckrpGemDesc');
      if (gemDesc) gemDesc.textContent = 'Valódi ' + (gemName || '').toLowerCase()
        + ' ásvány — '
        + (arch === 'male' ? (C.maleName || '') : arch === 'female' ? (C.femaleName || '') : 'az archetípus')
        + ' energiakövével';
    }

    document.dispatchEvent(new CustomEvent('chakraw:archChanged', { detail: { arch: arch } }));
    updateUI();
  }

  // ── CSAT VÁLASZTÓ ─────────────────────────────────────────────
  document.querySelectorAll('.ckrp-buckle-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.ckrp-buckle-btn').forEach(function (b) {
        b.classList.remove('active');
      });
      btn.classList.add('active');
      S.buckleExtra = parseInt(btn.dataset.extra) || 0;
      S.buckleLabel = btn.dataset.buckle;
      S.buckleIcon  = btn.dataset.icon;
      S.buckleType  = btn.dataset.buckleType;
      var lbl  = el('ckrpBuckleLabel');
      if (lbl)  lbl.textContent = S.buckleLabel;
      var prop = el('ckrpBuckleProp');
      if (prop) prop.value = S.buckleLabel;
      updateUI();
    });
  });

  // ── ÁSVÁNYMEDÁL ───────────────────────────────────────────────
  function setGemState(value) {
    S.gem = value;
    var row = el('ckrpGemRow');
    var chk = el('ckrpGemCheck');
    if (row) row.classList.toggle('ckrp-extra-selected', S.gem);
    if (chk) {
      chk.textContent         = S.gem ? '✓' : '';
      chk.style.background  = S.gem ? 'linear-gradient(135deg,#b8972d,#e8c97a)' : '';
      chk.style.borderColor = S.gem ? '#c9a84c' : '';
    }
    var prop = el('ckrpGemProp');
    if (prop) prop.value = S.gem ? 'Igen' : '';

    if (S.gem && !S.stop)  setStopState(true, true);
    if (!S.gem)             setStopState(S.stop, false);
  }

  window.ckrpToggleGem = function () { setGemState(!S.gem); updateUI(); };

  // ── ENERGIAKAPOCS ─────────────────────────────────────────────
  function setStopState(value, locked) {
    S.stop = value;
    var row  = el('ckrpStopRow');
    var chk  = el('ckrpStopCheck');
    var desc = el('ckrpStopDesc');
    if (row) {
      row.classList.toggle('ckrp-extra-selected', S.stop);
      row.classList.toggle('ckrp-extra-locked', !!locked);
      row.style.pointerEvents = locked ? 'none' : '';
    }
    if (chk) {
      chk.textContent         = S.stop ? '✓' : '';
      chk.style.background  = S.stop ? 'linear-gradient(135deg,#b8972d,#e8c97a)' : '';
      chk.style.borderColor = S.stop ? '#c9a84c' : '';
    }
    if (desc) desc.textContent = locked
      ? 'Az ásványmedál az energiakapocsra kerül — automatikusan hozzáadva'
      : 'Spirituális fókuszpont — viseld medállal vagy önmagában';
    var prop = el('ckrpStopProp');
    if (prop) prop.value = S.stop ? 'Igen' : '';
  }

  window.ckrpToggleStop = function () {
    if (S.gem) return;
    setStopState(!S.stop, false);
    updateUI();
  };

  // ── POPUP ─────────────────────────────────────────────────────
  // Meglévő mérési popup függvények
  window.ckrpOpenPopup = function () {
    var p = el('ckrpMeasurePopup');
    if (p) p.classList.add('open');
  };
  window.ckrpClosePopup = function () {
    var p = el('ckrpMeasurePopup');
    if (p) p.classList.remove('open');
  };

  // ÚJ: Gyártási/szállítási idő popup függvények
  window.ckrpOpenDeliveryPopup = function () {
    var p = document.getElementById('ckrpDeliveryPopup');
    if (p) p.classList.add('open');
  };

  window.ckrpCloseDeliveryPopup = function () {
    var p = document.getElementById('ckrpDeliveryPopup');
    if (p) p.classList.remove('open');
  };

  // ESC billentyű kezelés mindkét popup-hoz
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (typeof ckrpClosePopup === 'function') ckrpClosePopup();
      window.ckrpCloseDeliveryPopup();
    }
  });


  // ── SLIDER & INPUT ────────────────────────────────────────────
  var slider  = el('ckrpSizeSlider');
  var cmInput = el('ckrpCmInput');
  if (slider) {
    slider.addEventListener('input',  function () { setCm(this.value); });
    slider.addEventListener('change', function () { setCm(this.value); });
  }
  if (cmInput) {
    cmInput.addEventListener('input', function () { setCm(this.value); });
    cmInput.addEventListener('blur',  function () { setCm(this.value); });
  }

  // ── ARCHETÍPUS GOMBOK ─────────────────────────────────────────
  document.querySelectorAll('.ckrp-arch-btn').forEach(function (btn) {
    btn.addEventListener('click', function () { selectArch(btn.dataset.arch); });
  });

  // ── SZINKRON ─────────────────────────────────────────────────
  document.addEventListener('chakraw:variantChanged', function (e) {
    if (e.detail && e.detail.arch) selectArch(e.detail.arch);
  });
  document.addEventListener('variant:changed', function () {
    updateVariantId(getZone(S.cm).name);
  });

  // ── INIT – megvárja a CkrCtx betöltődését ────────────────────
  function doInit() {
    if (!window.CkrCtx || !window.CkrCtx.sign) {
      // Még nem töltődött be – 30ms-onként újrapróbál (max 3 mp)
      if ((doInit._tries = (doInit._tries || 0) + 1) < 100) {
        setTimeout(doInit, 30);
      }
      return;
    }
    // CkrCtx elérhető – betöltjük az adatokat
    C = window.CkrCtx;
    setCm(26);
    selectArch('both');
  }
  doInit();

  // ── KOSÁR – AJAX TÖBB TÉTELEL ─────────────────────────────
  var cartForm = document.getElementById('ckrp-cart-form');
  if (cartForm) {
    cartForm.addEventListener('submit', function (e) {
      e.preventDefault();

      var cartBtn = el('ckrpCartBtn');
      if (cartBtn) {
        cartBtn.disabled = true;
        cartBtn.textContent = '⏳ Hozzáadás...';
      }

      var variantId = parseInt(el('ckrpVariantId').value);
      if (!variantId) {
        alert('Kérjük válassz méretet!');
        if (cartBtn) { cartBtn.disabled = false; cartBtn.textContent = '✦ Kosárba teszem'; }
        return;
      }

      var properties = {};
      cartForm.querySelectorAll('input[name^="properties"]').forEach(function(input) {
        var key = input.name.replace('properties[', '').replace(']', '');
        if (input.value) properties[key] = input.value;
      });

      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: properties }] })
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.status && data.status !== 200) throw new Error(data.description || 'Hiba');

        document.dispatchEvent(new CustomEvent('cart:updated'));

        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        } else {
          var notif = document.querySelector('cart-notification');
          if (notif && typeof notif.renderContents === 'function') {
            try { notif.renderContents(data); } catch(e) { window.location.href = '/cart'; }
          } else {
            window.location.href = '/cart';
          }
        }

        if (cartBtn) {
          cartBtn.disabled    = false;
          cartBtn.textContent = '✓ Kosárban!';
          cartBtn.style.background = 'linear-gradient(135deg,#1a5a10,#3a9a20)';
          setTimeout(function() {
            cartBtn.textContent      = '✦ Kosárba teszem';
            cartBtn.style.background = '';
          }, 2600);
        }
      })
      .catch(function(err) {
        console.error('[ChakRaw] Kosár hiba:', err);
        if (cartBtn) { cartBtn.disabled = false; cartBtn.textContent = '✦ Kosárba teszem'; }
        alert('Hiba történt. Kérjük próbáld újra.');
      });
    });
  }

})();
} // end CkrPricingInitialized guard